module.exports = __webpack_public_path__ + "static/media/study 220215.96444b7e.png";